module.exports = __webpack_public_path__ + "img/touxiang.1df0b084.png";